/* eslint-disable */
export const paymentState = {
  NOTUPLOADED: 0,
  WAITFORVERIF: 1,
  ACCEPTED: 2,
  REJECTED: 3,
};

const payment = {
  paymentStatus: paymentState.NOTUPLOADED,
  paymentNominal: 0,
  paymentId: 0,
};

const state = {
  payment: payment,
};

const getters = {
  getPaymentStatus: (state) => {
    return state.payment.paymentStatus;
  },
  getPaymentNominal: (state) => {
    return state.payment.paymentNominal;
  },
  getPaymentId: (state) => {
    return state.payment.paymentId;
  },
};

const mutations = {
  setPaymentStatus: (state, payload) => {
    state.payment.paymentStatus = payload.value;
  },
  setPaymentNominal: (state, payload) => {
    state.payment.paymentNominal = payload.value;
  },
  setPaymentId: (state, payload) => {
    state.payment.paymentId = payload.value;
  },
  setPayment: (state, payload) => {
    state.payment = payload.payment;
  },
};

const actions = {
  RESETPAYMENT: ({ commit }) => {
    commit("setPayment", { payment: payment });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
